// extracted by mini-css-extract-plugin
export var item = "style-module--item--2dpWS";
export var itemImage = "style-module--itemImage--33p5Z";
export var itemTitle = "style-module--itemTitle--2tet4";
export var itemDescr = "style-module--itemDescr--2GV8E";